// Short text fields have no per-kind config beyond the base title /
// description / required surface owned by FieldRow. The component exists
// so the discriminated render in FieldRow stays exhaustive without
// special-casing two of the six kinds at the call site.

export function ShortTextConfig(): JSX.Element | null {
  return null;
}
